import { getSession } from "next-auth/react";
import axios from "axios";
const API_URL = process.env.NEXT_PUBLIC_BACKEND_API_URL; 
let bondContainerData: Record<string, any> = {};  
const bondContainerHandler = async (event: any) => {
    const { modifiedField, modifiedFieldValue, viewMetadata, formData} = event;
    const session: any = await fetchUser();
    const token = session?.user?.accessToken || "";
    bondContainerData[modifiedField] = modifiedFieldValue?.value;
    const newFormData: any = {};
    const bondId = formData?.bond?.solidManyToOneValue;
    const bondData = await fetchBondData(bondId, token);
    if(bondContainerData?.size && bondContainerData?.type && bondData?.data?.line && bondData?.data?.location && (modifiedField === 'size' || modifiedField === 'type')){
        const containerSizeMasterRecord = await fetchContainerSizeMaster(bondContainerData.size, bondContainerData.type, bondData?.data?.line, bondData?.data?.location, token);
        const containerRecords = containerSizeMasterRecord?.data?.records || [];
        if (containerRecords?.length > 0){
            const container = containerRecords[0];
            newFormData.amountPerContainer = container?.amount;
        }
        else{
            newFormData.amountPerContainer = null;
        }
        return {
            layoutChanged: false,
            dataChanged: true,
            newFormData: newFormData
        }
    }
}

const fetchUser = async () => {
    let session: any = await getSession();
    return session;
}
const fetchBondData = async (bondId: number, token: any) => {
    try {
        const response = await axios.get(`${API_URL}/api/bond/${bondId}`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        });
        return response.data;
    } catch (error: any) {
        console.error("Error fetching bond data:", error.response?.data || error.message);
        return null;
    }
};
const fetchContainerSizeMaster = async (size: string, type: string, line:string, location: string, token:string) => {
    try {
        const filters = {
            size: { $eq: size},
            type: { $eq: type },
            line: {$eq: line},
            location: {$eq: location}
        };
        const params = new URLSearchParams();
        // Object.entries(filters).forEach(([key, value]) => {
        //     if (value && value.$eq) {
        //         params.append(`filters[${key}][$eq]`, value.$eq);
        //     }
        // });
        if (size) params.append("filters[size][$eq]", size);
        if (type) params.append("filters[type][$eq]", type);

        // Use LIKE to check if the string exists inside the stored JSON string
        if (line) params.append("filters[line][$contains]", `%${line}%`);
        if (location) params.append("filters[location][$contains]", `%${location}%`);
        const response = await axios.get(`${API_URL}/api/container-size-master`, {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            params
        });
        return response.data;
    } catch (error:any) {
        console.error("Error fetching vessel data:", error.response?.data || error.message);
        return null;
    }
};
export default bondContainerHandler;